import React, { useState } from 'react';
import styles from './rate.module.scss';

const StarRating = ({ id, onRatingChange, rate, disabled }) => {
  const [rating, setRating] = useState(rate);

  const handleRatingChange = (ratingValue) => {
    setRating(ratingValue);
    onRatingChange(ratingValue);
  };

  const handleCancelClick = () => {
    setRating(null);
    onRatingChange(null);
  };

  return (
    <div>
      {disabled == true && [...Array(5)].map((star, index) => {
        const ratingValue = index + 1;
        return (
          <label key={ratingValue}>
            <input
              type="radio"
              className={styles.startInput}
              name={`rating-${id}`}
              value={ratingValue}
              disabled={true}
              onClick={() => handleRatingChange(ratingValue)}
            />
            <span className={disabled? styles.startInputWrapperdisable:styles.startInputWrapper }>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill={ratingValue <= rating ? '#2DA6C0' : '#FFFFFF'} stroke="#2DA6C0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
              </svg>
              {/* <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                <path d="M8.53834 1.24832C8.70914 0.837669 9.29086 0.837669 9.46166 1.24832L11.5278 6.21579C11.5998 6.38891 11.7626 6.5072 11.9495 6.52218L17.3123 6.95211C17.7556 6.98766 17.9354 7.54091 17.5976 7.83024L13.5117 11.3302C13.3693 11.4522 13.3071 11.6436 13.3506 11.826L14.5989 17.0592C14.7021 17.4918 14.2315 17.8337 13.8519 17.6019L9.26063 14.7975C9.10062 14.6998 8.89938 14.6998 8.73937 14.7975L4.14806 17.6019C3.76851 17.8337 3.29788 17.4918 3.40108 17.0592L4.64939 11.826C4.69289 11.6436 4.6307 11.4522 4.48831 11.3302L0.402413 7.83024C0.0646446 7.54091 0.244408 6.98766 0.687735 6.95211L6.05054 6.52218C6.23744 6.5072 6.40024 6.38891 6.47225 6.2158L8.53834 1.24832Z" fill={ratingValue <= rating ? '#2DA6C0' : '#F2F4F7'} />
              </svg> */}
            </span>
          </label>
        );
      })
      }
      {disabled == false && [...Array(5)].map((star, index) => {
        const ratingValue = index + 1;
        return (
          <label key={ratingValue} id={`shared_rate_starLabelId.${index}`}>
            <input
              type="radio"
              className={styles.startInput}
              name={`rating-${id}`}
              id={`shared_rate_star.${index}`}
              value={ratingValue}
              disabled={false}
              onClick={() => handleRatingChange(ratingValue)}
            />
            <span className={styles.startInputWrapper}>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill={ratingValue <= rating ? '#2DA6C0' : '#FFFFFF'} stroke="#2DA6C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
              </svg>
            </span>
          </label>
        );
      })
      }
      {disabled == false && (
        <span onClick={handleCancelClick} className={styles.cancelIcon} id="shared_rate_starcancelBtnId">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-refresh-ccw"><polyline points="1 4 1 10 7 10"></polyline>
            <polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
          </svg>
        </span>
      )

      }
    </div>
  );
};

export default StarRating;